import React from 'react'
import LocalAsyncStore from '../../../local-async-store'
import CCMSGovEnrolments from './ccms-gov-enrolments'

export const apiEndpointGovEnrolments = ({ child: record }) =>
  record.ccms_enrolments_path

export default props => {
  if (!props.child.ccms_enrolments_path)
    return (
      <CCMSGovEnrolments
        {...props}
        ccms_gov_enrolments={{
          loading: false,
          data: []
        }}
      />
    )

  const RenderLocalAsyncStore = LocalAsyncStore(
    'ccms_gov_enrolments',
    CCMSGovEnrolments,
    apiEndpointGovEnrolments
  )

  return <RenderLocalAsyncStore {...props} />
}



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccms-gov-enrolments/index.js